import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { IoLogoWhatsapp } from 'react-icons/io5';
import { useNavigate, useSearchParams } from 'react-router-dom';
import FailedIcon from '../assets/images/error.svg';

export default function Failed() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [bookingDetails, setBookingDetails] = useState({});

  useEffect(() => {
    const bookingId = sessionStorage.getItem('bookingId');
    const bookingPaymentId = sessionStorage.getItem('bookingPaymentId');

    const paymentId =
      searchParams.get('paymentId') || searchParams.get('PaymentID');
    if (!paymentId || !bookingId || !bookingPaymentId) {
      return navigate('/', { replace: true });
    }
    // setRenderContent(true);
    setBookingDetails(
      JSON.parse(sessionStorage.getItem('bookingDetails') || '{}')
    );
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {t('paymentFailed')} - {t('emstellCourse')}
        </title>
      </Helmet>
      <div className="max-w-5xl mx-auto mt-5 top-0 px-4 lg:px-0">
        <div className="bg-white rounded-3xl p-6 shadow-md shadow-black/5">
          <div className="max-w-sm mx-auto">
            <h2 className="font-semibold text-lg text-center">
              {t('registrationFailed')}
            </h2>
            <div className="flex justify-center mt-5">
              <img src={FailedIcon} alt="Success Icon" className="w-10" />
            </div>
            <p className="text-xs text-gray-500 sm:px-10 mt-6 text-center tracking-wide leading-[21px]">
              {t('registrationFailedBankDetails')}
            </p>
            <div className="sm:px-10 text-xs mt-6 space-y-2 font-medium text-center">
              {t('courseName')} : {bookingDetails?.courseName}
            </div>

            <div className="flex justify-center mt-5">
              <a
                href={bookingDetails?.paymentUrl}
                className="bg-gradient-to-r from-blue-700 via-violet-600 to-purple-500 text-xs px-6 py-3 rounded-full text-center text-white tracking-wide min-w-[12rem] hover:opacity-90">
                {t('tryAgain')}
              </a>
            </div>

            <div className="flex justify-center mt-5 mb-5">
              <div className="flex space-x-3 sm:space-x-8 items-center ">
                <span className="text-xs text-gray-600">
                  {t('forAnyQueries')}
                </span>

                <a
                  href="https://api.whatsapp.com/send/?phone=96550692333&text=Message+from+Launch+Online+Workshop+Success+Page"
                  target="_blank"
                  rel="noreferrer">
                  <IoLogoWhatsapp className="text-green-500" size={25} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
